import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-plum-deep" data-id="element-315" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-316" data-mp="2bvcrk6r6u6gg">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-317" data-mp="1x06lxkw089nn">
          Launch offer
        </p>
        <h2 className="mt-3 font-display font-semibold text-white text-2xl sm:text-4xl" data-id="element-318" data-mp="21x6rzvsutcer">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-319" data-mp="1o58qo75dwkt5">
          <Countdown tone="dark" data-id="element-320" data-mp="1sybk8fa5vu9c" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-321" data-mp="1sz4p1apk89ou">
          After that the price goes up by{' '}
          <span className="font-semibold text-coral-soft" data-id="element-322" data-mp="1eaqiopsxq33j">$5</span> and stays
          there.
        </p>
      </div>
    </section>;
}